//@mui
import { Box, useTheme, Grid, Typography, IconButton } from "@mui/material";
import Iconify from "~src/components/Iconify";
import BrandAvatar from "~src/components/BrandAvatar";
import { BrandResult } from "../SearchBar";
import {colors} from "~src/data/brandTabColors.ts"

type PropsType = {
  handleAnalyseButtonClick: () => void;
  selectedBrands: BrandResult[];
  setSelectedBrands:
    | React.Dispatch<React.SetStateAction<BrandResult[]>>
    | undefined;
};


export default function BrandTabs({
  selectedBrands,
  setSelectedBrands,
}: PropsType) {
  const theme = useTheme();

  const removeBrand = (removing_brand_id: number) => {
    if (setSelectedBrands) {
      setSelectedBrands((prevBrands) =>
        prevBrands.filter((brand) => parseInt(brand.id) !== removing_brand_id),
      );
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.common.white,
        borderRadius: "12px",
        border: `1px solid ${theme.palette.grey[200]}`,
        mb: 2,
        p: 2,
      }}
    >
      <Grid container spacing={2}>
        {selectedBrands?.map((brand, index) => (
          <Grid  sx={{ display: "flex", alignItems: "center" }} key={index}>
            {index !== 0 && index !== selectedBrands.length && (
              <Typography sx={{ mr: 2 }}>VS</Typography>
            )}
            <Box
              sx={{
                backgroundColor: theme.palette.common.white,
                borderRadius: "12px",
                border: `1px solid`,
                borderLeft: `10px solid`,
                borderColor: colors[index],
                px: "15px",
                py: "10px",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <BrandAvatar
                brandName={brand.brand_name}
                profileImage={brand.image}
                size={40}
                sx={{
                  border: `0.75px solid ${theme.palette.grey[300]}`,
                  mr: 1,
                }}
              />
              <Typography>{brand?.brand_name}</Typography>
              <IconButton
                sx={{ ml: "auto" }}
                onClick={() => removeBrand(parseInt(brand.id))}
              >
                <Iconify
                  icon={"solar:close-circle-line-duotone"}
                  width={20}
                  height={20}
                />
              </IconButton>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
